import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["id", "innerHTML"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExcerptOverlay',
    props: {
        highlights: {},
        focusAreaId: {},
        renderWhenEmpty: { type: Boolean },
        mirrorsContent: { type: Boolean }
    },
    setup(__props) {
        // Setup
        return (_ctx, _cache) => {
            return (__props.renderWhenEmpty || __props.highlights)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    id: `${__props.focusAreaId}-highlights`,
                    class: _normalizeClass([
                        'rc-highlight-area rc-highlight-area-content transcript-excerpt-overlay',
                        __props.mirrorsContent ? 'rc-RTEContent' : 'transcript-excerpt-overlay--flattened'
                    ]),
                    "aria-hidden": "true",
                    inert: "",
                    innerHTML: __props.highlights
                }, null, 10, _hoisted_1))
                : _createCommentVNode("", true);
        };
    }
});
